(() => {
 const header=document.querySelector('.cgl-head');
 const nav=header?.querySelector('.cgl-navigation');
 if(!nav || nav.dataset.ready) return;
 nav.dataset.ready='true';
 const menus=[...nav.querySelectorAll('.cgl-nav-disclosure')];
 const toggle=header.querySelector('.cgl-menu-toggle');
 const close=()=>{menus.forEach(m=>m.open=false);header.removeAttribute('data-nav-open');toggle?.setAttribute('aria-expanded','false');};
 toggle?.addEventListener('click',()=>{const open=!header.hasAttribute('data-nav-open');close();header.toggleAttribute('data-nav-open',open);toggle.setAttribute('aria-expanded',String(open));});
 menus.forEach(menu=>{
   let timer;
   menu.addEventListener('mouseenter',()=>{if(!matchMedia('(hover:hover) and (min-width:1201px)').matches)return;clearTimeout(timer);menus.forEach(m=>m.open=m===menu);});
   menu.addEventListener('mouseleave',()=>{if(matchMedia('(hover:hover) and (min-width:1201px)').matches)timer=setTimeout(()=>menu.open=false,220);});
   menu.addEventListener('toggle',()=>{if(menu.open)menus.forEach(m=>{if(m!==menu)m.open=false;});});
 });
 const tabs=[...nav.querySelectorAll('[role=tab]')];
 const select=tab=>tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;document.getElementById(t.getAttribute('aria-controls')).hidden=!active;});
 tabs.forEach((tab,i)=>{
   tab.addEventListener('click',()=>select(tab));
   tab.addEventListener('keydown',e=>{if(!['ArrowDown','ArrowUp','Home','End'].includes(e.key))return;e.preventDefault();const next=e.key==='Home'?0:e.key==='End'?tabs.length-1:(i+(e.key==='ArrowDown'?1:tabs.length-1))%tabs.length;select(tabs[next]);tabs[next].focus();});
 });
 document.addEventListener('pointerdown',e=>{if(!header.contains(e.target))close();});
 header.addEventListener('keydown',e=>{if(e.key==='Escape'){const active=menus.find(m=>m.open);if(active){active.open=false;active.querySelector('summary').focus();}else{close();toggle?.focus();}}});
})();
